import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-section-tiles" }

import Mail from '@/assets/images/infoSection/mail.png?as=webp&w=50&h=50';
import Telephone from '@/assets/images/infoSection/telefon.png?as=webp&w=50&h=50';
import Chat from '@/assets/images/infoSection/chat.png?as=webp&w=50&h=50';
import BaseEmail from '@/components/widgets/BaseEmail.vue';
import BasePhone from '@/components/widgets/BasePhone.vue';
import InfoSectionTile from './InfoSectionTile.vue';

import { useTidio } from '@/stores/Tidio';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSectionTiles',
  setup(__props) {

const tidio = useTidio();
const { isTidioChatEnabledBasedOnEditionStage } = storeToRefs(tidio);
const openChat = () => {
    tidio.openChat();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InfoSectionTile, {
      image: _unref(Telephone),
      title: _ctx.$t('home.infoSection.callUs'),
      class: "pre-wrap",
      text: _ctx.$t('home.infoSection.phoneNumberInfo')
    }, {
      subtitle: _withCtx(() => [
        _createVNode(BasePhone, {
          phone: _ctx.$t('home.infoSection.phoneNumber')
        }, null, 8, ["phone"])
      ]),
      _: 1
    }, 8, ["image", "title", "text"]),
    _createVNode(InfoSectionTile, {
      image: _unref(Mail),
      title: _ctx.$t('home.infoSection.textUs')
    }, {
      text: _withCtx(() => [
        _createVNode(BaseEmail, {
          class: "f-20 font-weight-medium",
          email: _ctx.$t('home.infoSection.contactEmail')
        }, null, 8, ["email"])
      ]),
      _: 1
    }, 8, ["image", "title"]),
    (_unref(isTidioChatEnabledBasedOnEditionStage))
      ? (_openBlock(), _createBlock(InfoSectionTile, {
          key: 0,
          image: _unref(Chat),
          title: 'Live Chat',
          class: "pre-wrap",
          text: _ctx.$t('home.infoSection.liveChatInfo')
        }, {
          title: _withCtx(() => [
            _createElementVNode("button", {
              class: "info-section-tiles_button",
              onClick: openChat
            }, _toDisplayString(_ctx.$t('home.infoSection.liveChat')), 1)
          ]),
          _: 1
        }, 8, ["image", "text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})